<template>
  <div class="eqtree-children">
    <LeafContainer
      v-for="child in items"
      :key="child.stateId"
      :item="child"
      :state="state"
      @open="$emit('open', $event)"
      @click="$emit('click', $event)"
      @hover="$emit('hover', $event)"
      @zoom-item="$emit('zoom-item', $event)"
      @mouseenter="$emit('mouseenter', $event)"
      @mouseleave="$emit('mouseleave', $event)"
      @mousein="$emit('mousein', $event)"
    >
      <template slot-scope="{ item }">
        <slot :item="item" />
      </template>
    </LeafContainer>
  </div>
</template>

<script>
export default {
  props: ['items', 'state'],
  beforeCreate() {
    this.$options.components.LeafContainer = require('./LeafContainer.vue').default
  },
}
</script>